export const sanitizeString = (str: string) => {
  if (str !== "") {
    const auxString = str.toLowerCase().replace(/ /g, "");
    return auxString;
  }
  return str;
};
